import { render, staticRenderFns } from "./BCKeyAssignmentMenu.vue?vue&type=template&id=74b6ca06&scoped=true"
import script from "./BCKeyAssignmentMenu.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentMenu.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentMenu.vue?vue&type=style&index=0&id=74b6ca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6ca06",
  null
  
)

export default component.exports